export default "__VITE_ASSET__D25G7yov__"